import { useTranslation } from "react-i18next";
import useDataQualityData from "../../data/useDataQualityData";

const useDataQualityDetectorsOverviewTable = (params) => {
  const { t } = useTranslation();
  const { data, loading, error } = useDataQualityData(params);

  // Define the table headers
  const columns = [
    { Header: t("dataQuality.detectorsOverview.columns.id"), accessor: "detector_id" },
    { Header: t("dataQuality.detectorsOverview.columns.date"), accessor: "date" },
    { Header: t("dataQuality.detectorsOverview.columns.intersection"), accessor: "intersection" },
    { Header: t("dataQuality.detectorsOverview.columns.vendor"), accessor: "vendor" },
    { Header: t("dataQuality.detectorsOverview.columns.flow"), accessor: "flow" },
    { Header: t("dataQuality.detectorsOverview.columns.link"), accessor: "link" },
    { Header: t("dataQuality.detectorsOverview.columns.detector"), accessor: "detector" },
    { Header: t("dataQuality.detectorsOverview.columns.expectedRecords"), accessor: "expected_records" },
    { Header: t("dataQuality.detectorsOverview.columns.retrievedRecords"), accessor: "retrieved_records" },
    { Header: t("dataQuality.detectorsOverview.columns.completenessPercent"), accessor: "percentage_completeness" },
    { Header: t("dataQuality.detectorsOverview.columns.invalidRecords"), accessor: "invalid_count" },
    { Header: t("dataQuality.detectorsOverview.columns.invalidPercent"), accessor: "percentage_invalid" },
    { Header: t("dataQuality.detectorsOverview.columns.flow0Count"), accessor: "zero_flow_count" },
    { Header: t("dataQuality.detectorsOverview.columns.flow0Percent"), accessor: "percentage_zeroes" },
  ];

  function filterByVendor(value) {
    const upperValue = value.toUpperCase();
    if (upperValue === "YUNEX") {
      return data.filter(item => item.vendor.toUpperCase() === "SIEMENS");
    }
    return data.filter(item => item.vendor.toUpperCase() === upperValue);
  }
  function filterByDetector(value) {
    return data.filter(item => item.detector_id === value);
  }
  
  
  let showData = [];
  if (params.selectedDetectors.length > 0) {
    showData = filterByDetector(params.selectedDetectors[0].id);
  } else if(params.location === "Network"){
    showData = filterByVendor(params.detector);
  }else {
    showData = data;
  }

  const unknown = t("dataQuality.detectorsOverview.unknown");
  const rows = showData.map((item, index) => ({
    detector_id: item.detector_id || unknown,
    date: item.date,
    intersection: item.intersection || unknown,
    vendor: item.vendor || unknown,
    flow: item.flow || unknown,
    link: item.link || unknown,
    detector: item.detector || unknown,
    expected_records: item.expected_records || "0",
    retrieved_records: item.retrieved_records || "0",
    percentage_completeness: item.percentage_completeness || "0",
    invalid_count: item.invalid_count || "0",
    percentage_invalid: item.percentage_invalid || "0",
    zero_flow_count: item.zero_flow_count || "0",
    percentage_zeroes: item.percentage_zeroes || "0",
  }));

  // Return the table-ready data
  return {
    tableData: { columns, rows },
    loading,
    error,
  };
};

export default useDataQualityDetectorsOverviewTable;
